export default {
  init() {

  	$('.help_adv_src h4').click(function(){
  		$('.adv_search_popup').fadeIn(1000);
  		$('.overlay_popup').fadeIn(1000);
  	});

  	$('.overlay_popup, .remove_popup_help').click(function(){
  		$('.adv_search_popup').fadeOut(1000);
  		$('.overlay_popup').fadeOut(1000);
  	});

    $('.mmaa_next').click(function(){

      $('.overlay_gif_animation').fadeIn()

      setTimeout(function(){

        $('.overlay_gif_animation').fadeOut()

      },1500);

    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/advanced-search.js